var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBgRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 889,
    height: 900,
    viewBox: "0 0 889 900",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "94.254%",
    y1: "11.624%",
    x2: "63.854%",
    y2: "90.514%",
    id: "0a2jfs4aba"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A1C5",
    stopOpacity: 0.035,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A1C5",
    stopOpacity: 0.05,
    offset: "39.244%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A1C5",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.97 0h388.753v392.128z",
    fill: "#35A1C5",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.864 0 .708 898.003H888.72z",
    transform: "translate(0 .998)",
    fill: "url(#0a2jfs4aba)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBgRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bg-right.ce460fdcf1b0bf845db3b7ebcaf89d48.svg";